import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  title: {
    textTransform: props => props.transform,
    '&:not(:first-child)': {
      marginTop: theme.spacing(2)
    }
  }
}));

export function SectionMandatoryHeader({
  translationId,
  children,
  transform = 'uppercase',
  visable
}) {
  const classes = useStyles({ transform });
  const { formatMessage } = useIntl();
  const content = translationId
    ? formatMessage({ id: translationId })
    : children;
  return (
    <>
      <Typography className={classes.title} variant="subtitle1">
        {content}
        {!visable && <span style={{ color: 'red' }}>*</span>}
      </Typography>
    </>
  );
}

export default SectionMandatoryHeader;
